<template>
  <div class="order-page">
    <a-tabs
        class="tabs"
        :defaultActiveKey="params.statuses"
        @change="handelStatusChange"
    >
      <template v-for="tab in tabs">
        <a-tab-pane :key="tab.value">
          <span slot="tab">
            {{ tab.text }}
            <span style="color: red" v-if="tab.count > 0"
            >（{{ tab.count }}）</span
            >
          </span>
        </a-tab-pane>
      </template>
    </a-tabs>
    <a-row :gutter="30" style="padding-top: 30px">
      <a-col span="8" style="margin-bottom: 25px">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">过保时间</a-col>
          <a-col span="18">
            <a-range-picker
                showTime
                style="display: block; width: auto"
                format="YYYY-MM-DD"
                v-model="params.time"
            />
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom: 25px">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">所在城市</a-col>
          <a-col span="18">
            <a-cascader
                changeOnSelect
                :options="options"
                v-model="params.city"
                :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
                placeholder="请选择城市"
                style="display: block"
                @click="getOptions"
            >
              <a-icon slot="suffixIcon" :type="options ? 'down' : 'loading'"/>
            </a-cascader>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom: 25px">
        <!-- <a-row type="flex" align="top">
          <a-col span="6" class="form-label">职位名称</a-col>
          <a-col span="18">
            <a-input style="display:block" placeholder="请输入关键字" v-model="params.job_name"></a-input>
          </a-col>
        </a-row>-->
        <a-input-group compact>
          <a-select v-model="params.jobType" style="width: 35%">
            <a-select-option value="job_id">职位ID</a-select-option>
            <a-select-option value="job_name">职位名称</a-select-option>
          </a-select>
          <a-input
              v-model="params.jobValue"
              style="width: 65%"
              placeholder="请输入关键字"
          ></a-input>
        </a-input-group>
      </a-col>
      <a-col span="8" style="margin-bottom: 25px">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">公司名称</a-col>
          <a-col span="18">
            <a-input
                style="display: block"
                placeholder="请输入关键字"
                v-model="params.company_name"
            ></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom: 25px">
        <a-input-group compact>
          <a-select v-model="params.main" style="width: 35%">
            <a-select-option value="user_tel">猎头手机</a-select-option>
            <a-select-option value="user_email">猎头邮箱</a-select-option>
            <a-select-option value="user_name">猎头姓名</a-select-option>
          </a-select>
          <a-input
              v-model="params.mainValue"
              style="width: 65%"
              placeholder="请输入关键字"
          ></a-input>
        </a-input-group>
      </a-col>
      <a-col span="8" style="margin-bottom: 25px">
        <a-input-group compact>
          <a-select v-model="params.resume" style="width: 35%">
            <a-select-option value="resume_mobile">候选人手机</a-select-option>
            <a-select-option value="resume_email">候选人邮箱</a-select-option>
            <a-select-option value="resume_name">候选人姓名</a-select-option>
          </a-select>
          <a-input
              v-model="params.resumeValue"
              style="width: 65%"
              placeholder="请输入关键字"
          ></a-input>
        </a-input-group>
      </a-col>
      <a-col span="8" style="margin-bottom: 25px">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">IE</a-col>
          <a-col span="18">
            <a-auto-complete
                allowClear
                style="display: block"
                :dataSource="suggestion"
                @search="handleSearch"
                v-model="params.ie_user_id"
                placeholder="请输入关键字"
            ></a-auto-complete>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom: 25px">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">订单号</a-col>
          <a-col span="18">
            <a-input
                style="display: block"
                placeholder="请输入关键字"
                v-model="params.order_no"
            ></a-input>
          </a-col>
        </a-row>
      </a-col>
      <!-- <a-col span="8" style="margin-bottom:25px;" v-if="params.statuses == 'CREATED,AUDIT_PASSED'">
        <a-row type="flex" align="middle" style="padding-top:5px">
          <a-col span="6" style="text-align:center">订单状态：</a-col>
          <a-col span="18">
            <a-radio-group v-model="params.sub_statuses">
              <a-radio value="CREATED,AUDIT_PASSED">全部</a-radio>
              <a-radio value="CREATE">新推荐</a-radio>
              <a-radio value="AUDIT_PASSED">审核通过</a-radio>
            </a-radio-group>
          </a-col>
        </a-row>
      </a-col>-->
    </a-row>
    <a-row type="flex" justify="space-between">
      <a-col>
        <a-button
            type="primary"
            style="margin-right: 12px; padding: 0 30px"
            @click="getFilterData()"
        >筛选
        </a-button
        >
        <a-button style="margin-right: 12px" @click="resetParams"
        >清空筛选条件
        </a-button
        >
        <span>共找到 {{ pagination.total }} 条信息</span>
      </a-col>
      <a-col
          v-if="isGranted('post_manager.post_' + order + '_list.btn_export_data')"
      >
        <a-button type="primary">导出数据</a-button>
      </a-col>
    </a-row>
    <div class="data-table" style="padding: 30px 0">
      <a-table
          :columns="columns"
          :dataSource="dataSource"
          rowKey="id"
          :pagination="pagination"
          :loading="loading"
          @change="getData"
          :customRow="rowClick"
      >
        <template slot="hunter" slot-scope="name, record">
          <span>{{ name }}</span>
          <span class="badge" v-if="record.is_sign == 1">签</span>
        </template>
        <template slot="status" slot-scope="status, record">
          <span
              :class="{
              tag: true,
              blue:
                [
                  'HUNTER_REFUSE','DELIVER'
                ].indexOf(status) > -1,
            }"
              v-if="record.source=='columbus_mini_app'"
          >投</span
          >
          <span
              :class="{
              tag: true,
              blue:
                [
                  'CREATED',
                  'AUDIT_PASSED',
                  'AUDIT_FAILED',
                  'SUBMIT_FAILED',
                ].indexOf(status) > -1,
            }"
          >推</span
          >
          <span
              :class="{
              tag: true,
              blue:
                [
                  'SUBMIT_PASSED',
                  'INTERVIEW',
                  'INTERVIEW_FAILED',
                  'CLOSED',
                ].indexOf(status) > -1,
            }"
          >面</span
          >
          <span :class="{ tag: true, blue: ['OFFERED'].indexOf(status) > -1 }"
          >录</span
          >
          <span
              :class="{
              tag: true,
              blue: ['ENTERED', 'NOT_ENTERED'].indexOf(status) > -1,
            }"
          >职</span
          >
          <span
              :class="{
              tag: true,
              blue:
                ['COMPLETED', 'NOT_COMPLETED', 'UNSETTLED', 'SETTLED'].indexOf(
                  status
                ) > -1,
            }"
          >保</span
          >
        </template>
        <template slot="action" slot-scope="{ status }, record">
          <div v-if="record.ie_user_id == $store.state.user.uid">
            <a-row
                type="flex"
                justify="center"
                align="middle"
                v-if="status == 'DELIVER'"
            >
              <a-col>
                <a-button type="link" @click.stop="nextStep('受理并推荐', record)"
                >受理并推荐
                </a-button
                >
                <br/>
                <a-button
                    type="link"
                    @click.stop="stopStep('审核不通过', record)"
                >审核不通过
                </a-button
                >
              </a-col>
            </a-row>
            <a-row
                type="flex"
                justify="center"
                align="middle"
                v-if="status == 'CREATED'"
            >
              <a-col>
                <a-button type="link" @click.stop="nextStep('审核通过', record)"
                >审核通过
                </a-button
                >
                <br/>
                <a-button
                    type="link"
                    @click.stop="stopStep('审核不通过', record)"
                >审核不通过
                </a-button
                >
              </a-col>
              <a-col style="marginright: 15px">
                <a-divider
                    type="vertical"
                    style="margin: 0; height: 15px; background: #00a2eb"
                ></a-divider>
              </a-col>
              <a-col>
                <a-dropdown>
                  <a @click.prevent.stop>
                    更多
                    <a-icon type="down"></a-icon>
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item
                        @click="drawer = true;order_id=record.id;communicate.key='7'"
                    >回款开票
                    </a-menu-item
                    >
                    <a-menu-item
                        @click="$refs.addCommunicationModal.show(record)"
                    >沟通记录
                    </a-menu-item
                    >
                    <a-menu-item @click="$refs.commentModal.show(record)"
                    >软性点评
                    </a-menu-item
                    >
                    <a-menu-item @click="$refs.preview.show(record.attachment)"
                    >附件简历
                    </a-menu-item
                    >
                    <a-menu-item>
                      <a
                          :href="
                          baseUrl +
                          '/resume/downloadAttachment?attachment_id=' +
                          record.attachment.id +
                          '&token=' +
                          $store.state.token
                        "
                          download
                      >下载简历附件</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                          :href="
                          baseUrl +
                          '/post/report/downloadPdfReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        "
                          download
                      >简历报告(PDF)</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                          :href="
                          baseUrl +
                          '/post/report/downloadDocReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        "
                          download
                      >简历报告(DOC)</a
                      >
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </a-col>
            </a-row>
            <a-row
                type="flex"
                justify="center"
                align="middle"
                v-if="status == 'AUDIT_PASSED'"
            >
              <a-col>
                <a-button type="link" @click.stop="nextStep('推荐通过', record)"
                >推荐通过
                </a-button
                >
                <br/>
                <a-button
                    type="link"
                    @click.stop="stopStep('推荐不通过', record)"
                >推荐不通过
                </a-button
                >
              </a-col>
              <a-col style="marginright: 15px">
                <a-divider
                    type="vertical"
                    style="margin: 0; height: 15px; background: #00a2eb"
                ></a-divider>
              </a-col>
              <a-col>
                <a-dropdown>
                  <a @click.prevent.stop>
                    更多
                    <a-icon type="down"></a-icon>
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item
                        @click="$refs.addCommunicationModal.show(record)"
                    >沟通记录
                    </a-menu-item
                    >
                    <a-menu-item @click="$refs.commentModal.show(record)"
                    >软性点评
                    </a-menu-item
                    >
                    <a-menu-item @click="$refs.preview.show(record.attachment)"
                    >附件简历
                    </a-menu-item
                    >
                    <a-menu-item>
                      <a
                          :href="
                          baseUrl +
                          '/resume/downloadAttachment?attachment_id=' +
                          record.attachment.id +
                          '&token=' +
                          $store.state.token
                        "
                          download
                      >下载简历附件</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                          :href="
                          baseUrl +
                          '/post/report/downloadPdfReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        "
                          download
                      >简历报告(PDF)</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                          :href="
                          baseUrl +
                          '/post/report/downloadDocReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        "
                          download
                      >简历报告(DOC)</a
                      >
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </a-col>
            </a-row>
            <a-row
                type="flex"
                justify="center"
                align="middle"
                v-if="status == 'SUBMIT_PASSED'"
            >
              <a-col>
                <a-button
                    type="link"
                    @click.stop="$refs.arrangeInterviewModal.show(record)"
                >安排面试
                </a-button
                >
                <br/>
              </a-col>
              <a-col style="marginright: 15px">
                <a-divider
                    type="vertical"
                    style="margin: 0; height: 15px; background: #00a2eb"
                ></a-divider>
              </a-col>
              <a-col>
                <a-dropdown>
                  <a @click.prevent.stop>
                    更多
                    <a-icon type="down"></a-icon>
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item
                        @click="$refs.addCommunicationModal.show(record)"
                    >沟通记录
                    </a-menu-item
                    >
                    <a-menu-item @click="$refs.commentModal.show(record)"
                    >软性点评
                    </a-menu-item
                    >
                    <a-menu-item @click="$refs.preview.show(record.attachment)"
                    >附件简历
                    </a-menu-item
                    >
                    <a-menu-item>
                      <a
                          :href="
                          baseUrl +
                          '/resume/downloadAttachment?attachment_id=' +
                          record.attachment.id +
                          '&token=' +
                          $store.state.token
                        "
                          download
                      >下载简历附件</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                          :href="
                          baseUrl +
                          '/post/report/downloadPdfReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        "
                          download
                      >简历报告(PDF)</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                          :href="
                          baseUrl +
                          '/post/report/downloadDocReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        "
                          download
                      >简历报告(DOC)</a
                      >
                    </a-menu-item>
                    <a-menu-item @click="stopStep('关闭订单', record)"
                    >关闭订单
                    </a-menu-item
                    >
                  </a-menu>
                </a-dropdown>
              </a-col>
            </a-row>
            <a-row
                type="flex"
                justify="center"
                align="middle"
                v-if="status == 'INTERVIEW'"
            >
              <a-col
                  v-if="
                  record.interviews.length > 0 &&
                  record.interviews[0].status === 'PROCESS'
                "
              >
                <a-button
                    type="link"
                    @click.stop="$refs.checkInterviewModal.show(record)"
                >标记面试结果
                </a-button
                >
                <br/>
                <a-button
                    type="link"
                    @click.stop="$refs.cancelInterviewModal.show(record)"
                >取消面试
                </a-button
                >
              </a-col>
              <a-col v-else>
                <a-button
                    type="link"
                    @click.stop="$refs.arrangeInterviewModal.show(record)"
                >安排下一轮面试
                </a-button
                >
                <br/>
                <a-button
                    type="link"
                    @click.stop="$refs.offerModal.show(record)"
                >发送offer
                </a-button
                >
              </a-col>
              <a-col style="marginright: 15px">
                <a-divider
                    type="vertical"
                    style="margin: 0; height: 15px; background: #00a2eb"
                ></a-divider>
              </a-col>
              <a-col>
                <a-dropdown>
                  <a @click.prevent.stop>
                    更多
                    <a-icon type="down"></a-icon>
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item
                        @click="$refs.addCommunicationModal.show(record)"
                    >沟通记录
                    </a-menu-item
                    >
                    <a-menu-item @click="$refs.commentModal.show(record)"
                    >软性点评
                    </a-menu-item
                    >
                    <a-menu-item @click="$refs.preview.show(record.attachment)"
                    >附件简历
                    </a-menu-item
                    >
                    <a-menu-item>
                      <a
                          :href="
                          baseUrl +
                          '/resume/downloadAttachment?attachment_id=' +
                          record.attachment.id +
                          '&token=' +
                          $store.state.token
                        "
                          download
                      >下载简历附件</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                          :href="
                          baseUrl +
                          '/post/report/downloadPdfReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        "
                          download
                      >简历报告(PDF)</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                          :href="
                          baseUrl +
                          '/post/report/downloadDocReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        "
                          download
                      >简历报告(DOC)</a
                      >
                    </a-menu-item>
                    <!-- <a-menu-item
                      v-if="
                        record.interviews.length == 1 &&
                          record.interviews[0].status === 'PROCESS'
                      "
                      @click="stopStep('关闭订单', record)"
                    >关闭订单</a-menu-item>-->
                    <a-menu-item @click="stopStep('关闭订单', record)"
                    >关闭订单
                    </a-menu-item
                    >
                  </a-menu>
                </a-dropdown>
              </a-col>
            </a-row>
            <a-row
                type="flex"
                justify="center"
                align="middle"
                v-if="status == 'OFFERED'"
            >
              <a-col>
                <a-button type="link" @click.stop="nextStep('已入职', record)"
                >已入职
                </a-button
                >
                <br/>
                <a-button type="link" @click.stop="stopStep('未入职', record)"
                >未入职
                </a-button
                >
              </a-col>
              <a-col style="marginright: 15px">
                <a-divider
                    type="vertical"
                    style="margin: 0; height: 15px; background: #00a2eb"
                ></a-divider>
              </a-col>
              <a-col>
                <a-dropdown>
                  <a @click.prevent.stop>
                    更多
                    <a-icon type="down"></a-icon>
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item
                        @click="$refs.addCommunicationModal.show(record)"
                    >沟通记录
                    </a-menu-item
                    >
                    <a-menu-item @click="$refs.commentModal.show(record)"
                    >软性点评
                    </a-menu-item
                    >
                    <a-menu-item @click="$refs.preview.show(record.attachment)"
                    >附件简历
                    </a-menu-item
                    >
                    <a-menu-item>
                      <a
                          :href="
                          baseUrl +
                          '/resume/downloadAttachment?attachment_id=' +
                          record.attachment.id +
                          '&token=' +
                          $store.state.token
                        "
                          download
                      >下载简历附件</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                          :href="
                          baseUrl +
                          '/post/report/downloadPdfReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        "
                          download
                      >简历报告(PDF)</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                          :href="
                          baseUrl +
                          '/post/report/downloadDocReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        "
                          download
                      >简历报告(DOC)</a
                      >
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </a-col>
            </a-row>
            <a-row
                type="flex"
                justify="center"
                align="middle"
                v-if="status == 'ENTERED'"
            >
              <a-col>
                <a-button type="link" @click.stop="nextStep('已过保', record)"
                >已过保
                </a-button
                >
                <br/>
                <a-button type="link" @click.stop="stopStep('未过保', record)"
                >未过保
                </a-button
                >
              </a-col>
              <a-col style="marginright: 15px">
                <a-divider
                    type="vertical"
                    style="margin: 0; height: 15px; background: #00a2eb"
                ></a-divider>
              </a-col>
              <a-col>
                <a-dropdown>
                  <a @click.prevent.stop>
                    更多
                    <a-icon type="down"></a-icon>
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item
                        @click="$refs.addCommunicationModal.show(record)"
                    >沟通记录
                    </a-menu-item
                    >
                    <a-menu-item @click="$refs.commentModal.show(record)"
                    >软性点评
                    </a-menu-item
                    >
                    <a-menu-item @click="$refs.preview.show(record.attachment)"
                    >附件简历
                    </a-menu-item
                    >
                    <a-menu-item>
                      <a
                          :href="
                          baseUrl +
                          '/resume/downloadAttachment?attachment_id=' +
                          record.attachment.id +
                          '&token=' +
                          $store.state.token
                        "
                          download
                      >下载简历附件</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                          :href="
                          baseUrl +
                          '/post/report/downloadPdfReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        "
                          download
                      >简历报告(PDF)</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                          :href="
                          baseUrl +
                          '/post/report/downloadDocReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        "
                          download
                      >简历报告(DOC)</a
                      >
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </a-col>
            </a-row>
            <a-row
                type="flex"
                justify="center"
                align="middle"
                v-if="status == 'COMPLETED'"
            >
              <a-col>
                <a-button type="link" @click.stop="nextStep('归档', record)"
                >归档
                </a-button
                >
              </a-col>
              <a-col style="marginright: 15px">
                <a-divider
                    type="vertical"
                    style="margin: 0; height: 15px; background: #00a2eb"
                ></a-divider>
              </a-col>
              <a-col>
                <a-dropdown>
                  <a @click.prevent.stop>
                    更多
                    <a-icon type="down"></a-icon>
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item
                        @click="$refs.addCommunicationModal.show(record)"
                    >沟通记录
                    </a-menu-item
                    >
                    <a-menu-item @click="$refs.commentModal.show(record)"
                    >软性点评
                    </a-menu-item
                    >
                    <a-menu-item @click="$refs.preview.show(record.attachment)"
                    >附件简历
                    </a-menu-item
                    >
                    <a-menu-item>
                      <a
                          :href="
                          baseUrl +
                          '/resume/downloadAttachment?attachment_id=' +
                          record.attachment.id +
                          '&token=' +
                          $store.state.token
                        "
                          download
                      >下载简历附件</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                          :href="
                          baseUrl +
                          '/post/report/downloadPdfReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        "
                          download
                      >简历报告(PDF)</a
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <a
                          :href="
                          baseUrl +
                          '/post/report/downloadDocReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        "
                          download
                      >简历报告(DOC)</a
                      >
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </a-col>
            </a-row>
          </div>
          <div v-else>
            <a-button
                type="link"
                @click.stop="$refs.preview.show(record.attachment)"
            >附件简历
            </a-button
            >
          </div>
        </template>
      </a-table>
    </div>

    <a-drawer
        :visible="drawer"
        :closable="false"
        width="1000"
        @close="drawer = !drawer"
        :destroyOnClose="true"
    >
      <a-row
          type="flex"
          justify="space-between"
          align="middle"
          style="paddingbottom: 40px"
      >
        <a-col style="cursor: pointer" @click="drawer = !drawer">
          <icon-font type="guanbi" :style="{ fontSize: '19px' }"/>
        </a-col>
        <a-col style="cursor: pointer" @click="viewDetail">
          <a-icon type="fullscreen"/>
          在新窗口打开
        </a-col>
      </a-row>
      <order-detail :id="order_id" :communicate="communicate.key"></order-detail>
    </a-drawer>
    <!-- //modal -->
    <failed-modal ref="failedModal" @ok="getData()"></failed-modal>
    <cancel-interview-modal
        ref="cancelInterviewModal"
        @ok="getData()"
    ></cancel-interview-modal>
    <check-interview-modal
        ref="checkInterviewModal"
        @ok="getData()"
        @cancel="unpassInterview"
    ></check-interview-modal>
    <offer-modal ref="offerModal" @ok="getData()"></offer-modal>
    <add-communication-modal
        ref="addCommunicationModal"
    ></add-communication-modal>
    <arrange-interview-modal
        ref="arrangeInterviewModal"
        @ok="getData()"
    ></arrange-interview-modal>
    <comment-modal ref="commentModal"></comment-modal>
    <resume-preview-modal ref="preview"></resume-preview-modal>
    <a-modal
        title="添加沟通记录"
        :confirmLoading="communicate.loading"
        :destroyOnClose="true"
        v-model="communicate.visible"
        @ok="handleOk"
    >
      <a-form :form="communicate.form">
        <a-form-item label="沟通记录">
          <a-textarea
              :rows="6"
              v-decorator="[
            'content',
            { rules: [{ required: true, message: '请填写沟通记录' }] },
          ]"
          ></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import moment from "moment";
import Api from "@/api";
import FailedModal from "./failed-modal";
import OrderDetail from "./order-detail";
import CancelInterviewModal from "./cancel-interview-modal";
import CheckInterviewModal from "./check-interview-modal";
import OfferModal from "./offer-modal";
import AddCommunicationModal from "./add-communication-modal";
import AddAttachmentModal from "./add-attachment-modal";
import ArrangeInterviewModal from "./arrange-interview-modal";
import ResumePreviewModal from "@/components/resume-preview-modal";
import CommentModal from "./comment-modal";
import baseComponentVue from "@/components/base-component.vue";
import {getOrderStatus} from "@/shared/utils/bootstrap";
import debounce from "lodash/debounce";

export default {
  name: "Order",
  extends: baseComponentVue,
  data() {
    this.handleSearch = debounce(this.handleSearch, 800);
    return {
      communicate: {
        loading: false,
        visible: false,
        form: this.$form.createForm(this),
        key: '0'
      },
      order: this.$route.params.status, //订单菜单类型
      baseUrl: process.env.VUE_APP_BASEURL,
      loading: false,
      dataSource: [],
      columns: [],
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
        pageSizeOptions: ["10", "20", "50"],
        showTotal: (total) => `共 ${total} 条`,
        showQuickJumper: true,
        showSizeChanger: true,
      },
      options: [],
      params: {},
      halfPage: false,
      order_id: undefined,
      suggestion: [],
      drawer: false,
    };
  },
  created() {
    this.resetParams();
    if (this.$route.query.type) {
      this.params.statuses = this.$route.query.type;
    } else {
      this.params.statuses = this.$route.query.tab || this.tabs[0].value;
      this.params.jobType = 'job_id';
      this.params.jobValue = this.$route.query.id;
    }
    console.log(this.params.jobType)
    console.log(this.params.jobValue)
    this.setColums();
    this.getData();
  },
  computed: {
    tabs() {
      let order = this.$store.getters.orderStatus(this.order);
      console.log(this.$store.getters.orderStatus(this.order));
      console.log(this.order)
      return order.child.filter(tab => tab.text !== '候选人投递');
    },
  },
  components: {
    FailedModal,
    OrderDetail,
    CancelInterviewModal,
    CheckInterviewModal,
    OfferModal,
    AddCommunicationModal,
    ArrangeInterviewModal,
    CommentModal,
    ResumePreviewModal,
  },
  methods: {
    handleOk() {

    },
    setColums() {
      this.order == "process"
          ? this.setActionColums()
          : this.setNoActionColums();
    },
    setActionColums() {
      let columns = [
        // {
        //   title: "做单号",
        //   dataIndex: "id",
        // },
        {
          title: "订单号",
          dataIndex: "order_no",
        },
        {
          title: "职位",
          dataIndex: "job_name",
        },
        {
          title: "候选人",
          dataIndex: "resume_name",
        },
        {
          title: "猎头",
          dataIndex: "hunter_name",
          scopedSlots: {customRender: "hunter"},
        },
        {
          width: "200px",
          align: "center",
          title: "订单阶段",
          dataIndex: "status",
          scopedSlots: {customRender: "status"},
        },
        {
          title: "订单状态",
          dataIndex: "status_text",
        },
        {
          title: "更新时间",
          dataIndex: "updated_at",
        },
      ];
      if (this.isGranted("post_manager.post_process_list.btn_list_audit")) {
        columns.push({
          align: "center",
          title: "操作",
          key: "action",
          scopedSlots: {customRender: "action"},
        });
      }
      this.columns = columns;
    },
    setNoActionColums() {
      this.columns = [
        // {
        //   title: "做单号",
        //   dataIndex: "id",
        // },
        {
          title: "订单号",
          dataIndex: "order_no",
        },
        {
          title: "职位",
          dataIndex: "job_name",
        },
        {
          title: "候选人",
          dataIndex: "resume_name",
        },
        {
          title: "猎头",
          dataIndex: "hunter_name",
          scopedSlots: {customRender: "hunter"},
        },
        {
          width: "200px",
          align: "center",
          title: "订单阶段",
          dataIndex: "status",
          scopedSlots: {customRender: "status"},
        },
        {
          title: "订单状态",
          dataIndex: "status_text",
        },
        {
          title: "更新时间",
          dataIndex: "updated_at",
        },
      ];
    },
    getFilterData() {
      this.pagination.current = 1;
      this.getData();
    },
    async getData(pagination, filters, sorter) {
      getOrderStatus();
      this.loading = true;
      if (pagination) {
        let pager = {...this.pagination};
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.pagination = pager;
      }
      let params = {
        statuses: this.params.statuses,
        created_start:
            this.params.time[0] && this.params.time[0].format("YYYY-MM-DD"),
        created_end:
            this.params.time[1] && this.params.time[1].format("YYYY-MM-DD"),
        province_id: this.params.city[0],
        city_id: this.params.city[1],
        dist_id: this.params.city[2],
        company_name: this.params.company_name,
        [this.params.main]: this.params.mainValue,
        [this.params.resume]: this.params.resumeValue,
        [this.params.jobType]: this.params.jobValue,
        order_no: this.params.order_no,
        ie_user_id: this.params.ie_user_id,
        page: this.pagination.current,
        limit: this.pagination.pageSize,
      };
      try {
        let response = await Api.order.getList(params);
        this.pagination.total = +response.total;
        this.dataSource = response.list;
      } catch (e) {
      }
      this.loading = false;
    },
    async getOptions() {
      this.options = undefined;
      let {tree} = await Api.common.getCityTree();
      this.options = tree;
    },
    handelStatusChange(key) {
      this.params.statuses = key;
      console.log(this.params.statuses)
      this.getFilterData();
    },
    resetParams() {
      let params = {
        time: [],
        city: [],
        company_name: "",
        main: "user_tel",
        jobType: "job_id",
        jobValue: "",
        mainValue: "",
        resume: "resume_mobile",
        resumeValue: "",
        ie_user_id: "",
      };
      this.params = {statuses: this.params.statuses, ...params};
    },
    rowClick(record) {
      return {
        on: {
          click: () => {
            this.drawer = true;
            this.order_id = record.id;
            this.communicate.key = '0';
          },
        },
      };
    },
    viewDetail(record) {
      this.drawer = false;
      let resolveDRoute = this.$router.resolve({
        path: `/order/detail/${this.order_id}`,
      });
      window.open(resolveDRoute.href, "_blank");
    },
    nextStep(text, record) {
      console.log(text, record)
      const h = this.$createElement;
      this.$confirm({
        title: "温馨提示",
        content: h("div", {style: {paddingTop: "20px"}}, [
          h("p", `确定要将简历标记为"${text}"`),
          h("p", "该操作不可逆，请谨慎操作"),
        ]),
        onOk: () => {
          //受理推荐
          if (record.status === "DELIVER") {
            return new Promise(async (resolve, reject) => {
              try {
                await Api.order.deliveryAudit({post_id: record.id});
                this.getData();
              } catch (e) {
              }
              resolve();
            });
          }
          //审核通过
          if (record.status === "CREATED") {
            return new Promise(async (resolve, reject) => {
              try {
                await Api.order.audit({post_id: record.id});
                this.getData();
              } catch (e) {
              }
              resolve();
            });
          }
          //推荐通过
          if (record.status === "AUDIT_PASSED") {
            return new Promise(async (resolve, reject) => {
              try {
                await Api.order.submit({post_id: record.id});
                this.getData();
              } catch (e) {
              }
              resolve();
            });
          }
          //入职
          if (record.status === "OFFERED") {
            return new Promise(async (resolve, reject) => {
              try {
                await Api.order.entered({post_id: record.id});
                this.getData();
              } catch (e) {
              }
              resolve();
            });
          }
          //过保
          if (record.status === "ENTERED") {
            return new Promise(async (resolve, reject) => {
              try {
                await Api.order.completed({post_id: record.id});
                this.getData();
              } catch (e) {
              }
              resolve();
            });
          }
          //归档
          if (record.status === "COMPLETED") {
            return new Promise(async (resolve, reject) => {
              try {
                await Api.order.done({post_id: record.id});
                this.getData();
              } catch (e) {
              }
              resolve();
            });
          }
        },
      });
    },
    stopStep(text, record) {
      let {failedModal} = this.$refs;
      failedModal.title = text;
      failedModal.show(record);
    },
    // 标记面试未通过
    unpassInterview(record) {
      let {failedModal} = this.$refs;
      failedModal.title = "面试未通过";
      failedModal.show(record);
    },
    //IE 搜索建议
    async handleSearch(value) {
      if (!value) return;
      let response = await Api.account.suggest({name: value});
      let arr = [];
      response.forEach((item) => {
        arr.push({value: item.uid, text: item.name});
      });
      this.suggestion = arr;
    },
    downloadResume(record) {
      Api.resume.downloadResume({attachment_id: record.attachment.id});
    },
    downloadReport(record) {
      Api.resume.downloadReport({resume_id: record.resume_id});
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.order = to.params.status;
    this.params.statuses = this.tabs[0].value;
    this.resetParams();
    this.setColums();
    //路由更新请求列表
    this.$nextTick().then(() => {
      this.getFilterData();
    });
    next();
  },
};
</script>
<style lang="scss">
.order-page {
  .ant-table-row {
    cursor: pointer;
  }
}

.tag {
  border: 1px solid #00a2eb;
  padding: 2px 3px;

  &.blue {
    color: #fff;
    background: #00a2eb;
  }

  &:not(:first-child) {
    border-left: none;
  }
}

.badge {
  position: relative;
  display: inline-block;
  color: #fff;
  background: rgb(224, 9, 9);
  font-size: 12px;
  padding: 0 2px;
  border-radius: 2px;
  top: -8px;
  left: 2px;
}

.half-page {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;

  .content-box {
    position: absolute;
    top: 0;
    right: 0;
    width: 1600px;
    height: 100%;
    overflow: auto;
    background: #fff;
    box-shadow: 0px 0px 44px 0px rgba(0, 0, 0, 0.16);
    padding: 30px 40px;

    .close {
      cursor: pointer;
    }

    .new_win {
      cursor: pointer;
      color: #999;
      display: flex;
      align-items: center;

      .anticon {
        font-size: 16px;
        margin-right: 6px;
      }
    }
  }
}
</style>
